export const MAX_WORKS_PER_ARTIST = 3;
